import { render, staticRenderFns } from "./PayPayment.vue?vue&type=template&id=651d5328&"
import script from "./PayPayment.vue?vue&type=script&lang=ts&"
export * from "./PayPayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports